import React from 'react';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { formatCatalogItemDate } from '@cp/entities/catalogItem';
import type { DateISOString } from '@common/types/dateISOString';

export interface ProfileDatesProps {
  createdAt?: DateISOString;
  lastActivityAt?: DateISOString;
}

export const ProfileDates: React.FC<ProfileDatesProps> = ({ createdAt, lastActivityAt }) => {
  if (!createdAt && !lastActivityAt) {
    return null;
  }

  return (
    <Stack gap={1}>
      {createdAt ? (
        <Typography sx={{ lineHeight: '20px' }} variant="body">
          <Typography component="span" sx={{ color: 'gray' }} variant="body">
            Дата регистрации:
          </Typography>{' '}
          {formatCatalogItemDate(new Date(createdAt), true)}
        </Typography>
      ) : null}
      {lastActivityAt ? (
        <Typography sx={{ lineHeight: '20px' }} variant="body">
          <Typography component="span" sx={{ color: 'gray' }} variant="body">
            Последняя активность:
          </Typography>{' '}
          {formatCatalogItemDate(new Date(lastActivityAt), true)}
        </Typography>
      ) : null}
    </Stack>
  );
};
